const Graph = require('./BaseGraph')

module.exports = class CoreGraph extends Graph 
{
    constructor(apiDomain, path="core")
    {
        super(apiDomain, path)
    }

    countryQuery(fields, params=null)
    {
        if (params)
            return { type: 'country', query: this.queryString('country', fields, params)}

        return { type: 'country', query: `query getCountry ($code: String!) {
            country(code: $code)
            ${this.queryFields(fields)}
        }` }
    }

    countriesQuery(fields, params=null)
    {
        if (params)
            return { type: 'countries', query: this.queryString('countries', fields, params)}

        return { type: 'countries', query: `query getCountries ($search: String, $limit: Int, $offset: Int) {
            countries(search: $search, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }

    stateQuery(fields, params=null)
    {
        if (params)
            return { type: 'state', query: this.queryString('state', fields, params)}

        return { type: 'state', query: `query getState ($code: String!) {
            state(code: $code)
            ${this.queryFields(fields)}
        }` }
    }

    statesQuery(fields, params=null)
    {
        if (params)
            return { type: 'states', query: this.queryString('states', fields, params)}

        return { type: 'states', query: `query getStates ($country_code: String, $search: String, $limit: Int, $offset: Int) {
            states(country_code: $country_code, search: $search, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }
}